import { render, staticRenderFns } from "./QueueReportStatus.vue?vue&type=template&id=2c616940&scoped=true"
import script from "./QueueReportStatus.vue?vue&type=script&lang=js"
export * from "./QueueReportStatus.vue?vue&type=script&lang=js"
import style0 from "./QueueReportStatus.vue?vue&type=style&index=0&id=2c616940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c616940",
  null
  
)

export default component.exports